import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Approval } from '@interfaces';
import { DialogApprovalsEquipmentsDiffComponent } from 'app/main/approvals-equipments/dialog/dialog-approvals-diff/dialog-approvals-equipments.component';
import { DialogApprovalsEquipmentsComponent } from 'app/main/approvals-equipments/dialog/dialog-approvals-new/dialog-approvals-equipments.component';
import { ApprovalAndEquipment, ApprovalsEquipmentsApi } from 'app/main/approvals-equipments/services/api/approvals-equipments-api.service';
import { EquipmentsService } from 'app/main/equipments/services/equipments-resolver.service';
import { findIndex, reject, sortBy } from 'lodash';
import moment from 'moment-timezone';
import { CreateEquipmentApprovalsLogsService } from './services/create-equipment-approvals-logs.service';
import { CreateEquipmentLogsService } from './services/create-equipment-logs.service';
import { UpdatedByLogService } from './services/updated-by-log.service';

@Component({
  selector: 'tab-equipment-historic',
  templateUrl: './tab-equipment-historic.component.html',
  styleUrls: ['./tab-equipment-historic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabEquipmentHistoricComponent implements OnInit {
  public readonly todayDate = moment().format('DD/MM/YYYY');
  public readonly yesterdayDate = moment().subtract(1, 'days').format('DD/MM/YYYY');

  public equipmentLogsMapped = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData,
    private createEquipmentLogs: CreateEquipmentLogsService,
    private createApprovalsLogs: CreateEquipmentApprovalsLogsService,
    private updatedByLog: UpdatedByLogService,
    private fuseProgressBarService: FuseProgressBarService,
    private matDialog: MatDialog,
    private equipmentsService: EquipmentsService,
    private approvalsEquipmentsApi: ApprovalsEquipmentsApi
  ) {}

  async ngOnInit(): Promise<void> {
    const logsMerged = [];

    const approvals = this.dialogData.equipment == null ? [] : await this.approvalsEquipmentsApi.listApprovalsEquipments({
      where: {
        qrCode_contains: this.dialogData.equipment.qrCode,
        status_in: ['pending', 'approved', 'refused']
      },
      orderBy: 'createdAt_asc',
      offset: 0,
      limit: 10000
    }).toPromise().then((result) => result.items);

    const equipmentLogsMapped = this.createEquipmentLogs.listEquipmentLogsMapped(this.dialogData.equipment);

    const approvalLogsMapped = this.createApprovalsLogs.listApprovalsLogsMapped(this.dialogData.equipment.logs, approvals);

    let equipmentsLogsWithUpdatedBy = this.updatedByLog.customUpdatedByInLogs(equipmentLogsMapped);
    const approvalsLogsWithUpdatedBy = this.updatedByLog.customUpdatedByInLogs(approvalLogsMapped);

    approvalsLogsWithUpdatedBy.forEach((approvalLog) => {
      equipmentsLogsWithUpdatedBy = reject(equipmentsLogsWithUpdatedBy, (log) => {
        return approvalLog.approvedStatus === 'approved' &&
          moment(approvalLog.createdAt).isSame(moment(log.createdAt));
      });
    });

    logsMerged.push(
      ...approvalsLogsWithUpdatedBy,
      ...equipmentsLogsWithUpdatedBy);

    this.equipmentLogsMapped = sortBy(logsMerged, 'createdAt');


    const indexOfFirstApproval = findIndex(this.equipmentLogsMapped, (log) => log.approval);
    if (indexOfFirstApproval >= 0) {
      this.equipmentLogsMapped = reject(this.equipmentLogsMapped, (log, index) => {
        return index > indexOfFirstApproval && log.isEquipmentCreatedLog;
      });
    }

    this.equipmentLogsMapped = this.equipmentLogsMapped.reverse();
  }

  private getDialog(result: ApprovalAndEquipment): MatDialogRef<any> {
    if (result.equipment && result.approval.status === 'pending') {
      return this.matDialog.open(DialogApprovalsEquipmentsDiffComponent, {
        panelClass: ['dialog-approval-equipment-diff'],
        data: {
          approval: result.approval,
          equipment: result.equipment
        }
      });
    }

    return this.matDialog.open(DialogApprovalsEquipmentsComponent, {
      panelClass: ['dialog-approval-equipment'],
      data: result.approval
    });
  }

  async openDialog(approval: Approval): Promise<void> {
    this.fuseProgressBarService.show();

    const result = await this.equipmentsService.getApprovalAndEquipment({
      approvalId: approval.id,
      equipmentQrCode: approval.equipment.qrCode
    });

    this.fuseProgressBarService.hide();

    return this.getDialog(result).afterClosed().toPromise();
  }
}
